import React, { ChangeEvent } from "react";
import { Button, Grid } from "@material-ui/core";
import { Add as AddIcon } from "@material-ui/icons";
import ValidationResult from "../../../hooks/change-tracker/ValidationResult";
import { AuthorizedCarrier } from "../../../models/financing-request/AuthorizedCarrier";
import AuthorizedCarrierItem from "./AuthorizedCarrierItem";
import Currency from "../../../models/shared/Currency";

interface Props {
  authorizedCarriers: AuthorizedCarrier[];
  validationResult: ValidationResult;
  currency: Currency;
  onChange: (index: number) => (e: ChangeEvent<HTMLInputElement>) => void;
  onAdd: () => void;
  onDelete: (index: number) => void;
}

export default function AuthorizedCarrierList({
  authorizedCarriers,
  validationResult,
  currency,
  onChange,
  onAdd,
  onDelete
}: Props) {
  return (
    <Grid container spacing={5}>
      {authorizedCarriers != null && authorizedCarriers.length > 0
        ? authorizedCarriers.map(
            (authorizedCarrier: AuthorizedCarrier, index: number) => (
              <AuthorizedCarrierItem
                key={index.toString()}
                index={index}
                authorizedCarrier={authorizedCarrier}
                currency={currency}
                onChange={onChange(index)}
                onDelete={onDelete}
                validationResult={validationResult}
              />
            )
          )
        : null}
      <Grid item xs={12}>
        <Button variant="outlined" color="primary" size="small" onClick={onAdd}>
          <AddIcon />
          Dodaj ovlašteni prijevoz
        </Button>
      </Grid>
    </Grid>
  );
}
